<template>
  <div></div>
</template>
<script>
import { ZYToast } from '@zyf2e/adapt';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  async created() {
    ZYToast.open('加载中');
    const { settlementId } = this.$route.query;
    const { status, orderId } = await this.$fetch.fetchGetSettlementStatus({ settlementId }).catch(err => err);
    switch (status) {
      case 1: // 推荐单已经生成
        this.jumpToMallOrderDetail(orderId, 0);
        break;
      case 2:
        this.$router.replace({
          name: 'Settlement',
          query: this.$route.query
        });
        break;

      default:
        this.$toast('需求清单生成异常,请关闭重试');
        break;
    }
  }
};
</script>
